import AcquisitionChannelSelect from "@/components/form/acquisition-channel-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is an acquisition-channel key**; `""` = None. */
export type AcquisitionChannelFieldProps = PickerFieldProps<string>;

export const AcquisitionChannelField = makePickerField<string>({
  name: "AcquisitionChannelField",
  control: AcquisitionChannelSelect,
  popout: true,
});
